import { MantineSize } from '@mantine/core';
import { ThemeIcon } from 'src/design/atoms/ThemeIcon';
import { Tooltip } from 'src/design/atoms/Tooltip';
import { IconLink } from '@tabler/icons-react';
import React from 'react';
import { WbsTreeData } from 'src/routes/Jobs/WBS/components/types';
import { useWbs } from 'src/routes/Jobs/WBS/contexts/WbsContext';

export interface ICTCLinkIndicatorProps {
  label?: string;
  node: WbsTreeData;
  size?: MantineSize;
}
/** Green link icon shown on a WBS tree node whose labor estimates are sourced from CTC data; renders nothing for non-CTC or placeholder accounts. */
export const CTCLinkIndicator: React.FC<ICTCLinkIndicatorProps> = ({
  label = 'CTC Connected: Labor estimates are sourced from CTC data',
  size = 'sm',
  node,
}) => {
  const { isPlaceholderAccount, isCTCConnectedAccount } = useWbs();
  if (!isCTCConnectedAccount(node)) return null;
  if (isPlaceholderAccount(node.apply)) return null;

  return (
    <Tooltip label={label} withArrow>
      <ThemeIcon color="green" size={size} variant="light">
        <IconLink />
      </ThemeIcon>
    </Tooltip>
  );
};
